<template>
  <!-- 表格 -->
  <div>
    <div class="report_title">
      <label class="report-line" />
      <span class="report-title">月持仓汇总(取当月最后一个交易日的净订货)</span>
      <exportConfig
        :all-head="allHead"
        :header-name="headerName"
      />
    </div>
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="signHoldDateStr"
        label="成交日期"
      />
      <af-table-column
        fixed
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        fixed
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="holdBsDesc"
        label="购/销"
      />
      <af-table-column
        prop="buyHoldAmount"
        label="订货量"
      />
      <af-table-column
        prop="buyAvgPrice"
        label="订货均价"
      />
      <af-table-column
        prop="buyLockedAmount"
        label="锁仓量"
      />
      <af-table-column
        prop="buyFrozenAmount"
        label="冻结量"
      />
      <af-table-column
        prop="buyFrozenBailBalance"
        label="基本担保履约资金"
      />
      <af-table-column
        prop="buyHoldGainLoss"
        label="补充担保履约资金"
      />
    </el-table>
    <MoreData
      :all-data="allData"
      :table-data.sync="tableData"
    />
  </div>
</template>
<script>
import api from '@/api'
import dayJs from 'dayjs'
import MoreData from '@/components/more-data'
import exportConfig from '@/components/exportConfig'

export default {
  name: 'MonthlyPositionSummary',
  components: {
    MoreData,
    exportConfig,
  },
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      allHead: [{
        fieldLabel: '成交日期',
        excelColumn: 'signHoldDateStr'
      },
      {
        fieldLabel: '客户号',
        excelColumn: 'tradeUserAccount'
      },
      {
        fieldLabel: '购销计划',
        excelColumn: 'goodsCode'
      },
      {
        fieldLabel: '购/销',
        excelColumn: 'holdBsDesc'
      },
      {
        fieldLabel: '订货量',
        excelColumn: 'buyHoldAmount'
      },
      {
        fieldLabel: '订货均价',
        excelColumn: 'buyAvgPrice'
      },
      {
        fieldLabel: '锁仓量',
        excelColumn: 'buyLockedAmount'
      },
      {
        fieldLabel: '冻结量',
        excelColumn: 'buyFrozenAmount'
      },
      {
        fieldLabel: '基本担保履约资金',
        excelColumn: 'buyFrozenBailBalance'
      },
      {
        fieldLabel: '补充担保履约资金',
        excelColumn: 'buyHoldGainLoss'
      },
      ],
      currentPage: 1,
      total: 0,
      pageSize: 10,
      tableData: [], // 表格数据
      allData: [],
      headerName: '月报表_月持仓汇总',
    }
  },
  methods: {
    // 分页查询
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.monthDate = dayJs(this.query.date).format('YYYYMM')
      let res = await api.spotPurchaseSaleInquiry.MonthlyPositionSummary(param)
      this.allData = res.data || []
    },
  }
}

</script>

<style lang="scss" scoped>
  ::v-deep .el-table .el-table__body-wrapper tbody>tr:last-child td:nth-child(8) div {
    display: none;
  }

</style>
